/**
 * Push notifications registration state has changed.
 *
 * @public
 * @requires push
 * @memberof notification
 * @event notifications:change
 * @param {Object} params
 * @param {string} params.channel The channel for the notification.
 */
export const NOTI_CHANGE = 'notifications:change'

/**
 * An error occurred with push notifications.
 *
 * @public
 * @requires push
 * @memberof notification
 * @event notifications:error
 * @param {Object} params
 * @param {api.BasicError} params.error The Basic error object.
 * @param {string} params.channel The channel for the notification.
 */
export const NOTI_ERROR = 'notifications:error'

/**
 * A notification was received by the SDK.
 *
 * @private This is an undocumented feature.
 *
 * @event notification:received
 * @param {Object} params Object that has information about the notification.
 * @param {Object} params.payload The payload of the notification.
 */
export const NOTI_RECEIVED = 'notification:received'
